import React, { useEffect, useState } from 'react';

import { useHistory } from "react-router-dom";
import { store } from "react-notifications-component";

import api from '../../services/api';
import { login } from "../../services/auth";
import identifyErrorMenssage from '../../services/identifyErrorMenssage';

import InputV3 from '../../components/input/novo/input_v3';
import Modal from "../../components/modal/modalGeneric";
import GoogleLoginButton from '../../components/social-google-button-form';

import SetaCinza from '../../assets/icons/icon-right-gray.svg';
import SetaBranca from '../../assets/icons/icon-right-white.svg';
import LogoBranca from '../../assets/logo-agroreceita-branco.svg';

import * as S from './styles';
import { theme } from '../../styles/theme';
import { BodyG, BodyP, H3, TaglineM, TaglineP } from '../../styles/stylesTypography';
import maintainUtm from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";
import { isTotvs } from '../../services/globalFunctions';

export default function NovoLogin() {
    const history = useHistory();
    const [width, setWidth] = useState(window.innerWidth);

    const [email, setEmail] = useState('');
    const [errorEmailMsg, setErrorEmailMsg] = useState('');
    const [password, setPassword] = useState('');
    const [errorPasswordMsg, setErrorPasswordMsg] = useState('');

    const [emailRecover, setEmailRecover] = useState('');
    const [errorEmailRecoverMsg, setErrorEmailRecoverMsg] = useState('');

    const [loading, setLoading] = useState(false);
    const [loadingRecover, setLoadingRecover] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isButtonRecoverDisabled, setIsButtonRecoverDisabled] = useState(true);

    const [showModalRecoverPassword, setShowModalRecoverPassword] = useState(false);
    const [showModalCreateAccount, setShowModalCreateAccount] = useState(false);

    const [googleNome, setGoogleNome] = useState(''); 
    const [googleEmail, setGoogleEmail] = useState(''); 

    const [credentialLoginHash, setCredentialLoginHash] = useState('')
    const emailRecoverErrorTimeoutRef = React.useRef(null);

    const [errorLoginData, setErrorLoginData] = useState('');

    const redirectToApp = (fallbackPath) => {
        const encodedFallback = encodeURIComponent(fallbackPath);
        window.location = `/abrir-app?fallback=${encodedFallback}`;
    };

    useEffect(() => {
        loginQuery();

        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    function base64UrlDecode(string) {
        string = string.replace(/-/g, '+').replace(/_/g, '/');
        
        const padding = string.length % 4;
        if (padding) {
        string += '='.repeat(4 - padding);
        }

        let datas = atob(string);
        datas = datas.split(";");
        
        return datas;
    }

    function handleCredentialResponse(credential) {
        if (credential) {
            var profile = parseJwt(credential);  
            var google_user = { profile };
        
            var profileUserGoogle = {
                id: profile.sub,
                name: profile.name,
                email: profile.email
            }
        
            var exit = localStorage.getItem('@agroreceita_exit');
            
            localStorage.setItem('@useraccesskey', Buffer.from(profileUserGoogle.id, 'utf8').toString('base64'));
            localStorage.setItem("@agroreceita_google_email", profile.email);
            localStorage.setItem("@agroreceita_google_nome", profileUserGoogle.name);
            localStorage.setItem("@agroreceita_google_user", JSON.stringify(google_user));
            localStorage.setItem("@agroreceita_google_user_profile", JSON.stringify(profileUserGoogle));
        }
    }

    const changeUsername = (e) => {
        setEmail(e);
        // setErroEmail(false);
    }

    const changePassword = (e) => {
        setPassword(e);
        // setErroSenha(false);
    }

    const loginQuery = async () => {
        const origin = new URLSearchParams(window.location.search).get('origin');
        if (origin === 'app') {
            try {
                const token = new URLSearchParams(window.location.search).get('token');
                const headers = { 'apiKey': process.env.REACT_APP_API_KEY };
                const { data } = await api.get(`/userinfo/${token}`, { headers });
                const loginPayload = data?.data?.user ? data.data : data?.user ? data : null;

                if (!loginPayload?.user?.contrato) {
                    throw new Error('Payload inválido para auto login');
                }

                login(loginPayload);

                setTimeout(() => {
                    window.location = '/'
                }, 1500);
            } catch (error) {
                store.addNotification({
                    title: "Erro ao tentar login!",
                    message: identifyErrorMenssage(error, "ERRO-672 Não foi possível autenticar automaticamente com o token recebido - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } else {
            let queryLogin = decodeURIComponent(new URLSearchParams(window.location.search).get('q'));
            let loginInfos = queryLogin ? base64UrlDecode(queryLogin) : null;
            let queryCredential = decodeURIComponent(new URLSearchParams(window.location.search).get('credential'));
            const redirectParam = new URLSearchParams(window.location.search).get('redirect');
            if (redirectParam) {
                let queryRedirect;
    
                try {
                    queryRedirect = base64UrlDecode(decodeURIComponent(redirectParam));
                } catch (err) {
                    queryRedirect = null;
                }
    
                if (queryRedirect && queryRedirect.length > 0) {
                    const dominioAtual = window.location.origin;
                    const fullRedirectPath = `${dominioAtual}${queryRedirect[0]}`;
                    localStorage.setItem("lastAttemptedPath", fullRedirectPath);
                }
            }
    
            let queryIOS = decodeURIComponent(new URLSearchParams(window.location.search).get('ios'));
    
            if (queryIOS && queryIOS !== 'null') {
                localStorage.setItem('@agroreceita:ios', queryIOS);
            } else {
                localStorage.setItem('@agroreceita:ios', '');
            }
    
            if (queryCredential && queryCredential !== 'null') {
                setCredentialLoginHash(queryCredential);
                handleCredentialResponse(queryCredential);
            } else {
                if (loginInfos && loginInfos[1] && loginInfos[1] !== 'null' && loginInfos[0] && loginInfos[0] !== 'null') {
                    changeUsername(loginInfos[0]);
                    changePassword(loginInfos[1]);
        
                    setTimeout(() => {
                        handleSignIn(loginInfos[0], loginInfos[1], true);
                    }, 500);
                } else if (loginInfos && loginInfos[0] && loginInfos[2] && (loginInfos[2] === 'true' || loginInfos[2] === true)) {
                    const email = loginInfos[0];
                    
                    localStorage.setItem("@agroreceita_google_email", email);
                    
                    handleGoogleSuccess(localStorage.getItem("@agroreceita_google_nome") || email.split('@')[0], email);
                }
            }
        }
    }

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);

        setErrorEmailMsg('');
        setErrorPasswordMsg('');

        const trimmedEmail = newEmail.trim();

        setIsButtonDisabled(!trimmedEmail || !password || !!validateEmail(trimmedEmail));
    };

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;

        setErrorEmailMsg('');
        setErrorPasswordMsg('');

        const trimmedPassword = newPassword.trim();
        
        setPassword(trimmedPassword)

        setIsButtonDisabled(!trimmedPassword || !email || !!validateEmail(email));
    };

    const getLoginRedirectWithPreviousRoute = () => {
        const previousRoute = localStorage.getItem('next_route_plans');

        if (previousRoute) {
            localStorage.removeItem('next_route_plans');
            return `${previousRoute}`;
        }

        return null;
    };

    const handleGoogleSuccess = async (nome, googleEmail) => {
        setGoogleNome(nome);
        setGoogleEmail(googleEmail); 
        // setEmail(googleEmail);
        setErrorEmailMsg(validateEmail(googleEmail));
        setIsButtonDisabled(!!validateEmail(googleEmail) || !password);

        try {
            setLoading(true);
            setErrorEmailMsg('');
            setErrorPasswordMsg('');
        
            const headers = { 'apiKey': process.env.REACT_APP_API_KEY };
        
            const payload = {
                username: googleEmail,
                password: null, 
                loginSocial: 1,
                type: 'google',
            }; 
        
            const response = await api.post(`/login`, payload, { headers });
            const loginPayload = response?.data?.data?.user ? response.data.data : response?.data?.user ? response.data : null;
            if (!loginPayload?.user?.contrato) {
                throw new Error('Payload inválido para login social');
            }

            login(loginPayload);
            
            const isLogged = localStorage.getItem('@logged');
            const isOpen = localStorage.getItem('@open');
        
            if ((isLogged === 'false' || !isLogged) && (isOpen === 'false' || !isOpen)) {
                localStorage.setItem('@open', 'true');
                
                if (isTotvs() && loginPayload.user.agro_permission_id === 4) {
                    redirectToApp('/integracao-webhook');
                } else {
                    redirectToApp(`/apresentacao${maintainUtm()}`);
                }
            } else {
                if (isTotvs() && loginPayload.user.agro_permission_id === 4) {
                    redirectToApp('/usuarios');
                } else {
                    const redirectToPreviousRoute = getLoginRedirectWithPreviousRoute();
                    window.location = redirectToPreviousRoute || `/${maintainUtm()}`; 
                    redirectToApp(redirectToPreviousRoute || `/${maintainUtm()}`);
                }
            }
        
        } catch (error) {
            setErrorEmailMsg('Verifique suas credenciais!');
            setErrorPasswordMsg('Verifique suas credenciais!');

            localStorage.removeItem('@agroreceita_google_email');
            localStorage.removeItem('@agroreceita_google_user');
            localStorage.removeItem('@agroreceita_google_user_profile');
            setShowModalCreateAccount(true);

            const errorData = error?.response?.data || { errors: 'Falha na comunicação com o servidor.' };
            setErrorLoginData(errorData);

            if (error?.response?.data) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error, "ERRO-673 Falha ao tentar login - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: "A autenticação retornou, mas houve uma falha no processamento local.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

        } finally {
            setLoading(false);
        }
    };

    const handleEmailRecoverChange = (e) => {
        const trimmedEmail = e.target.value.trim();
        setEmailRecover(trimmedEmail);

        // Validação de habilitação do botão (imediata)
        const isValid = trimmedEmail ? validateEmail(trimmedEmail) === '' : false;
        setIsButtonRecoverDisabled(!isValid);

        // Controle do erro com debounce
        if (emailRecoverErrorTimeoutRef.current) {
            clearTimeout(emailRecoverErrorTimeoutRef.current);
        }

        // Campo vazio: sem erro
        if (!trimmedEmail) {
            setErrorEmailRecoverMsg('');
            return;
        }

        // E-mail válido: limpa erro imediatamente
        if (isValid) {
            setErrorEmailRecoverMsg('');
            return;
        }

        // Atraso para exibir erro quando inválido
        emailRecoverErrorTimeoutRef.current = setTimeout(() => {
            setErrorEmailRecoverMsg('Insira um e-mail válido.');
        }, 500);
    };


    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
        return regex.test(email) ? '' : "Insira um e-mail válido.";
    };

    const handleSignIn = async (e, p) => {
        if ((!email || !password) && (!e || !p)) {
            setErrorEmailMsg(!email ? "O e-mail é obrigatório." : "");
            setErrorPasswordMsg(!password ? "A senha é obrigatória." : "");

            store.addNotification({
                title: "Erro!",
                message: "Preencha os campos em vermelho para continuar",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
            return;
        }

        try {
            setLoading(true);
            setErrorEmailMsg('');
            setErrorPasswordMsg('');

            const headers = { 'apiKey': process.env.REACT_APP_API_KEY };

            const payload = {
                username: email || e,
                password: password || p
            };

            const { data } = await api.post(`/login`, payload, { headers });
            const loginPayload = data?.data?.user ? data.data : data?.user ? data : null;
            if (!loginPayload?.user?.contrato) {
                throw new Error('Payload inválido para login');
            }

            login(loginPayload);

            const rawPassword = password || p || '';
            const encodedPassword = (typeof window !== 'undefined' && typeof window.btoa === 'function')
                ? window.btoa(unescape(encodeURIComponent(rawPassword)))
                : rawPassword;
            localStorage.setItem('@useraccesskey', encodedPassword);

            if (isTotvs() && loginPayload.user.agro_permission_id === 4) {
                    redirectToApp(localStorage.getItem('@logged') === 'false' ? '/integracao-webhook' : "/usuarios");
            } else {
                const redirectToPreviousRoute = getLoginRedirectWithPreviousRoute();
                redirectToApp(localStorage.getItem('@logged') === 'false' ? `/apresentacao${maintainUtm()}` : (redirectToPreviousRoute || `/${maintainUtm()}`));
            }

        } catch (err) {
            setErrorEmailMsg('Verifique suas credenciais!');
            setErrorPasswordMsg('Verifique suas credenciais!');

            const errorData = err?.response?.data || { errors: 'Falha na comunicação com o servidor.' };
            setErrorLoginData(errorData);

            store.addNotification({
                title: "Erro ao tentar login!",
                message: identifyErrorMenssage(err, "ERRO-674 Falha ao tentar login - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            if (err?.response?.data) {
                setShowModalCreateAccount(true);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = (e) => {
        e.preventDefault();
        handleSignIn();
    };

    const pressKey = (e) => {
        if (e.code === 'Enter') {
            if (email && password) {
                handleSignIn();
            }
        }
    }

    const handleRecover = async () => {
        try {
            setLoadingRecover(true);
            setErrorEmailRecoverMsg('');
    
            const headers = { 'apiKey': process.env.REACT_APP_API_KEY };
    
            const payload = {
                username: emailRecover
            };
    
            const response = await api.post(`/recover`, payload, { headers });
    
            if (response.data) {
                store.addNotification({
                    title: "Verifique seu e-mail.",
                    message: "Enviamos o procedimento para recuperar sua senha",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
                setShowModalRecoverPassword(false);

                setEmailRecover('');
            } else {
                setErrorEmailRecoverMsg('Erro ao processar a solicitação.');

                store.addNotification({
                    title: "Erro!",
                    message: "Ocorreu um erro ao tentar recuperar sua senha.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
            }
    
        } catch (error) {
            setErrorEmailRecoverMsg('Verifique sua credencial!');
    
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-675 Ocorreu um erro ao tentar recuperar sua senha - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        } finally {
            setLoadingRecover(false);
        }
    };

    const handlePasswordRecover = (e) => {
        e.preventDefault();
        handleRecover();
    };

    const getUtmParams = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const utmParams = {};
        
        const utmKeys = ['utm_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'site_button'];
        
        utmKeys.forEach(key => {
            const value = searchParams.get(key);
            if (value) {
                utmParams[key] = value;
            }
        });
        
        return utmParams;
    };
    
    const getCadastroLink = () => {
        const utmParams = getUtmParams();
        
        const searchParams = new URLSearchParams();
        Object.entries(utmParams).forEach(([key, value]) => {
            searchParams.append(key, value);
        });

        if (searchParams.has('cupom')) {
             return `/cadastro?${searchParams.toString()}`;
        } else{
              const current = new URL(window.location.href);
              return `/cadastro${current.search}`;
        }
    };
    
    const handleCreateAccount = () => {
        let nome = '';
        let emailToUse = '';
        let obs = '';

        if (googleEmail) {
            nome = googleNome; 
            emailToUse = googleEmail; 
            obs = 'google'; 
        } else {
            emailToUse = email;
            obs = 'email'; 
        }
        
        const utmParams = getUtmParams();
        
        let pathname = "/cadastro";
        let search = '';
        
        if (Object.keys(utmParams).length > 0) {
            const searchParams = new URLSearchParams();
            Object.entries(utmParams).forEach(([key, value]) => {
                searchParams.append(key, value);
            });
            search = `?${searchParams.toString()}`;
        }

        history.push({
            pathname,
            search,
            state: { nome, email: emailToUse, obs, emailValidationForm: false }
        });
    };

    useEffect(() => {
        if (localStorage.getItem('@exit') === 'false') {
            localStorage.clear();
        }
    }, []);

    useEffect(() => {
       localStorage.removeItem('@userinfo');
    }, []);

    useEffect(() => {
        return () => {
            if (emailRecoverErrorTimeoutRef.current) {
                clearTimeout(emailRecoverErrorTimeoutRef.current);
            }
        };
    }, []);

    const forgotMyPassword = () => width <= 767 ? 'Recuperar senha' : 'Esqueci minha senha';
    const createAnAccount = () => width <= 767 ? 'Criar nova conta' : 'Não possuo cadastro';

    return (
        <S.Container>
            <S.Wrapper>
                <S.Description>
                    <img src={LogoBranca} alt='Logo do Agroreceita na cor barnca' />

                    <S.DescriptionText>
                        <H3 color={theme.colors.white.Branco}>Olá, seja bem vindo(a)!</H3>

                        <BodyG color={theme.colors.gray.Cinza_9}>Preencha os campos para entrar</BodyG>
                    </S.DescriptionText>
                </S.Description>

                <S.Form>
                    <GoogleLoginButton onSuccess={handleGoogleSuccess} />

                    <S.ContainerDivider>
                        <S.Divider />

                        <TaglineP color={theme.colors.gray.Cinza_2}>ou</TaglineP>

                        <S.Divider />
                    </S.ContainerDivider>

                    <InputV3
                        id="email"
                        type="text"
                        label="e-mail"
                        floatingLabelWithAsterisk="E-mail"
                        placeholder=""
                        value={email}
                        onChange={handleEmailChange}
                        isDisabled={false}
                        errorInfo={errorEmailMsg}
                        hasError={!!errorEmailMsg}
                        onKeyDown={(e) => pressKey(e)}
                    />

                    <InputV3
                        id="password"
                        type="password"
                        label="password"
                        floatingLabelWithAsterisk="Senha"
                        placeholder=""
                        value={password}
                        onChange={handlePasswordChange}
                        isDisabled={false}
                        errorInfo={errorPasswordMsg}
                        hasError={!!errorPasswordMsg}
                        onKeyDown={(e) => pressKey(e)}
                    />

                    <S.ContainerButtonsAndTerms>
                        <S.ContainerButtons>
                            <S.ContainerRegistration>
                                <BodyP color={theme.colors.blue.Azul_link} fontWeight={700} onClick={() => setShowModalRecoverPassword(true)}>{forgotMyPassword()}</BodyP>
                            </S.ContainerRegistration>

                            <S.FormButton
                                type="submit"
                                disabled={isButtonDisabled}
                                onClick={handleLogin}
                            >
                                {loading ? (
                                    <S.Loading />
                                ) : (
                                    <>
                                        <TaglineM fontWeight={800}>Entrar</TaglineM>

                                        <img src={isButtonDisabled ? SetaCinza : SetaBranca} alt='Seta' />
                                    </>
                                )}
                            </S.FormButton>
                        </S.ContainerButtons>

                        <a href={`/cadastro${maintainUtm()}`}>
                            <BodyP color={theme.colors.blue.Azul_link} fontWeight={700}>{createAnAccount()}</BodyP>
                        </a>
                    </S.ContainerButtonsAndTerms>
                </S.Form>
            </S.Wrapper>

            <Modal
                show={showModalRecoverPassword}
                size='sm'
                onHide={() => {
                    setShowModalRecoverPassword(false); 
                    setEmailRecover('');
                    setErrorEmailRecoverMsg('');
                    setIsButtonRecoverDisabled(true);
                    if (emailRecoverErrorTimeoutRef.current) {
                        clearTimeout(emailRecoverErrorTimeoutRef.current);
                    }
                }}
            >
                <S.ContainerModalRecover>
                    <H3 color={theme.colors.gray.Cinza_5}>Esqueceu a senha?</H3>

                    <BodyG color={theme.colors.gray.Cinza_5}>Digite o e-mail do usuário cadastrado para alterá-la.</BodyG>

                    <S.FormRecover>
                        <InputV3
                            id="email"
                            type="text"
                            label="e-mail"
                            floatingLabelWithAsterisk="E-mail"
                            placeholder=""
                            value={emailRecover}
                            onChange={handleEmailRecoverChange}
                            isDisabled={false}
                            errorInfo={errorEmailRecoverMsg}
                            hasError={!!errorEmailRecoverMsg}
                        />

                        <S.FormButton
                            type="submit"
                            disabled={isButtonRecoverDisabled}
                            onClick={handlePasswordRecover}
                        >

                        {loadingRecover ? (
                                <S.Loading />
                            ) : (
                                <>
                                    <TaglineM fontWeight={800}>Alterar senha</TaglineM>

                                    <img src={isButtonRecoverDisabled ? SetaCinza : SetaBranca} alt='Seta' />
                                </>
                            )}
                        </S.FormButton>
                    </S.FormRecover>
                </S.ContainerModalRecover>
            </Modal>

            <Modal
                show={showModalCreateAccount}
                size='sm'
                onHide={() => setShowModalCreateAccount(false)}
            >
                <S.ContainerModalAccountNotFound>
                    <H3 color={theme.colors.gray.Cinza_5}>{errorLoginData.errors === "Contrato vencido." ? "Contrato vencido!" : 'Registro não encontrado!'}</H3>

                    <BodyG color={theme.colors.gray.Cinza_5}>{errorLoginData.errors === "Contrato vencido." ?
                     "Seu contrato venceu, para acessar sua conta novamente, entre em contato com nosso suporte." :
                      'Verifique seu email e senha e tente novamente!'}
                    </BodyG>

                    <S.ContainerAccountNotFoundButtons>
                        <S.TryAgainButton
                            type="button"
                            onClick={() => setShowModalCreateAccount(false)}
                        >
                            <TaglineM fontWeight={800}>TENTAR NOVAMENTE</TaglineM>
                        </S.TryAgainButton>

                        {errorLoginData.errors === "Contrato vencido." ?
                            (
                                <S.FormButton
                                    type="button"
                                    onClick={() => window.open('https://api.whatsapp.com/send?phone=5515981657739', '_blank')}
                                >
                                    <TaglineM fontWeight={800}>Falar com Suporte</TaglineM>
                                </S.FormButton>
                            ) :
                            (
                                <S.FormButton
                                    type="button"
                                    onClick={handleCreateAccount}
                                >
                                    <TaglineM fontWeight={800}>CRIAR NOVA CONTA</TaglineM>
                                </S.FormButton>
                            )
                        }
                    </S.ContainerAccountNotFoundButtons>
                </S.ContainerModalAccountNotFound>
            </Modal>
        </S.Container>
    );
}
